import React from 'react'

import { Button, Dialog, DialogBody, DialogFooter, DialogHeader, Spinner } from '../../components'
import ChartLayout from '../../models/chart_layout'
import SocialShare from './social_share'
import { useImageGenerator } from './useImageGenerator'

export const DIALOG_ID = 'publishDialog'

export interface PublishDialogConfig {
  ticker: string
  timeframe: string
  isCanvas: boolean
  chartImgUrl: string | null
}

interface DialogContentProps {
  layoutModel: ChartLayout
  config?: PublishDialogConfig
}

function DialogContent({ layoutModel, config }: DialogContentProps) {
  const { isCanvas = true, chartImgUrl = null, ticker = null, timeframe = null } = config ?? {}
  const { isLoading, data } = useImageGenerator(
    isCanvas
      ? { layoutModel }
      : {
          imgUrl: chartImgUrl,
          ticker,
          timeframe,
        }
  )

  if (isLoading) {
    return (
      <div className="flex h-48 items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      <div className="flex flex-1 items-center justify-center">
        <img
          alt="Finviz Chart"
          src={data?.imgUrl}
          className="max-h-[50vh] max-w-full"
          data-testid="charts-publish-chart-img"
        />
      </div>
      <div className="mt-4 shrink-0 landscape-any:mt-0 landscape-any:w-1/2">
        {data && <SocialShare shareUrl={data?.shareUrl} ticker={data?.ticker} />}
      </div>
    </>
  )
}

interface PublishDialogProps {
  state: any
  config?: PublishDialogConfig
  layoutModel: ChartLayout
}

export default function PublishDialog(props: PublishDialogProps) {
  return (
    <Dialog state={props.state} aria-label="Publish chart" className="w-145" data-testid="charts-publish-modal">
      <DialogHeader onCloseClick={() => props.state.hide()}>Publish chart</DialogHeader>
      <DialogBody className="landscape-any:flex landscape-any:space-x-2">
        <DialogContent layoutModel={props.layoutModel} config={props.config} />
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => props.state.hide()} data-testid="charts-publish-modal-cancel">
          Close
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
